import kebabCase from 'lodash/kebabCase'

export const asyncSleep = (timeout: number = 1000) =>
  new Promise((resolve) => {
    setTimeout(resolve, timeout)
  })

export const formatPrice = (price: string) => `$${price}`

export const rangeMap = <T>(
  times: number = 0,
  callback: (i: number) => T
): T[] => Array.from({ length: times }, (_, i) => callback(i))

export const slug = (name: string) => kebabCase(name)
